import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
        return
    }
    next('/')
  }
  
const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next()
        return
    }
    next('/login')
}

const routes = [
    {
        path: '/',
        component: () => import('@/pages/home.vue'),
        beforeEnter: ifAuthenticated
    },
    { 
        path: '/login',
        component: () => import('@/pages/login.vue'),
        beforeEnter: ifNotAuthenticated
    }
];

export default new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes
});
